var map = {
	"./de-DE": [
		"4Uan",
		17
	],
	"./de-DE.js": [
		"4Uan",
		17
	],
	"./en-GB": [
		"3eia",
		16
	],
	"./en-GB.js": [
		"3eia",
		16
	],
	"./en-US": [
		"Lf1N"
	],
	"./en-US.js": [
		"Lf1N"
	],
	"./es-ES": [
		"bPoU",
		15
	],
	"./es-ES.js": [
		"bPoU",
		15
	],
	"./es-MX": [
		"uHT2",
		14
	],
	"./es-MX.js": [
		"uHT2",
		14
	],
	"./fr-CA": [
		"mbgl",
		13
	],
	"./fr-CA.js": [
		"mbgl",
		13
	],
	"./fr-FR": [
		"FEBf",
		12
	],
	"./fr-FR.js": [
		"FEBf",
		12
	],
	"./id-ID": [
		"Vndk",
		11
	],
	"./id-ID.js": [
		"Vndk",
		11
	],
	"./pl-PL": [
		"eaaQ",
		10
	],
	"./pl-PL.js": [
		"eaaQ",
		10
	],
	"./pt-BR": [
		"iI64",
		9
	],
	"./pt-BR.js": [
		"iI64",
		9
	],
	"./pt-PT": [
		"L1Dz",
		8
	],
	"./pt-PT.js": [
		"L1Dz",
		8
	],
	"./ru-RU": [
		"XH4h",
		7
	],
	"./ru-RU.js": [
		"XH4h",
		7
	],
	"./th-TH": [
		"leD0",
		6
	],
	"./th-TH.js": [
		"leD0",
		6
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "BcZ7";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/i18n/langs lazy ^\.\/.*$
// module id = BcZ7
// module chunks = 23